export const scenariosWhiteList: string[] = [
  'central', 'high', 'low', 'ltp24', 'ltp25', 'ltp25 (basecase) - energy', 'release_q3_25', 'ltp26 (lastest)'
];
